export default __webpack_public_path__ + "static/media/screenShots_fund-3.afe47718.jpg";